export default __webpack_public_path__ + "static/media/leonard-cohen-happens-to-the-heart.34b1a2e2.mp3";